import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "filterData",
})
export class FilterDataPipe implements PipeTransform {
  transform(items: any[], searchText: string): any[] {
    if (!items || !searchText) {
      return items;
    }

    searchText = searchText.toLowerCase();

    return items.filter((item) => {
      // Modify this condition to match your search criteria.
      return (
        item.username.toLowerCase().includes(searchText) || // Example: Search in the username field
        item.batcode.toLowerCase().includes(searchText)
      ); // Add other fields as needed
    });
  }
}
